module.exports = __webpack_public_path__ + "media/images/categories/carousel/internet-and-new-economy-a0b87fd0890820e41eb241efff6ac57b.jpg";